import { cn } from "../../lib/utils";

interface CloseCircleIconProps {
  className?: string;
  variant?: "default" | "destructive" | "success";
}

const CloseCircleIcon = ({ className }: CloseCircleIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="#FF4172"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-4 2xl:size-5", className)}
    >
      <path d="M10 0C4.42857 0 0 4.42857 0 10C0 15.5714 4.42857 20 10 20C15.5714 20 20 15.5714 20 10C20 4.42857 15.5714 0 10 0ZM13.8571 15L10 11.1429L6.14286 15L5 13.8571L8.85714 10L5 6.14286L6.14286 5L10 8.85714L13.8571 5L15 6.14286L11.1429 10L15 13.8571L13.8571 15Z" />
    </svg>
  );
};

export default CloseCircleIcon;
